module.exports = __webpack_public_path__ + "static/11-1d9e607333947b7b02b321edcbb72e73.png";